"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteToolHeading = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var QuoteToolHeading = exports.QuoteToolHeading = function QuoteToolHeading(_ref) {
  var headingText = _ref.headingText,
    _ref$mandatoryText = _ref.mandatoryText,
    mandatoryText = _ref$mandatoryText === void 0 ? 'Mandatory fields' : _ref$mandatoryText,
    _ref$showMandatoryTex = _ref.showMandatoryText,
    showMandatoryText = _ref$showMandatoryTex === void 0 ? false : _ref$showMandatoryTex,
    customCssClass = _ref.customCssClass;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "quoteToolHeading ".concat(showMandatoryText ? 'mandatoryText' : 'noMandatoryText', " ").concat(customCssClass || '')
  }, /*#__PURE__*/_react["default"].createElement("h1", null, headingText), showMandatoryText && /*#__PURE__*/_react["default"].createElement(_components.MandatoryMessage, {
    mandatoryText: mandatoryText
  }));
};
QuoteToolHeading.propTypes = {
  headingText: _propTypes["default"].string,
  mandatoryText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  showMandatoryText: _propTypes["default"].bool,
  customCssClass: _propTypes["default"].string
};